<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" *ngIf="!oneLine">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2 align-middle">
    <a href="tel:+33825159559">
      <img src="assets/img/num_indigo.png" style="max-width: 100%" alt="Contact Provalt"/>
    </a>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2 align-middle">
    <h4 i18n="@@or">or</h4>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 align-middle">
    <a href="mailto:contact@provalt.fr">
      <h4>contact&#64;provalt.fr</h4>
    </a>
  </div>
</div>

<div class="row" *ngIf="oneLine">
  <div class="col-12 col-sm-5 col-md-5 col-lg-5 col-xl-5 align-middle">
    <a href="tel:+33825159559">
      <img src="assets/img/num_indigo.png" style="max-width: 100%" alt="Contact Provalt"/>
    </a>
  </div>

  <div class="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 align-middle">
    <h4 i18n="@@or">or</h4>
  </div>

  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 align-middle">
    <a href="mailto:contact@provalt.fr">
      <h4>contact&#64;provalt.fr</h4>
    </a>
  </div>
</div>
